import { useIsFeatureEnabled } from '@thriveglobal/thrive-web-core'
import { HLSPlayer } from '@thriveglobal/thrive-web-leafkit'
import Hls from 'hls.js'
import React, { useMemo } from 'react'
import { getIframeVideoManifestSrc } from './utils'
import { Stream, StreamProps } from '@thriveglobal/cloudflare-stream-react'

export type StreamPlayerWithHLSFallbackProps = StreamProps

const IsFallbackResetPlayerEnabledFeatureFlag = 'IsFallbackResetPlayerEnabled'

function StreamPlayerWithHLSFallback(
    props: StreamPlayerWithHLSFallbackProps
): JSX.Element {
    const { src, streamRef, ...restProps } = props
    const isFallbackEnabled = useIsFeatureEnabled(
        IsFallbackResetPlayerEnabledFeatureFlag,
        false,
        true
    )

    const isFallback = useMemo(
        () => isFallbackEnabled && Hls.isSupported(),
        [isFallbackEnabled]
    )

    const manifestSrc = useMemo<string>(
        () => getIframeVideoManifestSrc(src),
        [src]
    )

    if (isFallback) {
        return (
            <HLSPlayer
                {...restProps}
                src={manifestSrc}
                ref={streamRef as React.MutableRefObject<HTMLVideoElement>}
            />
        )
    } else {
        return <Stream {...restProps} streamRef={streamRef} src={src} />
    }
}

export default React.memo(StreamPlayerWithHLSFallback)
